<template>
  <KioskContainer />
</template>

<script lang="ts">
import Vue from "vue";
import KioskContainer from "@/components/kiosk/container/KioskContainer.vue";

export default Vue.extend({
  components: {
    KioskContainer,
  },
});
</script>
